const OpenResumeInNewTab = (base64Data) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Detect MIME type
  let mimeType = "application/pdf";
  if (base64Data.includes("JVBER")) {
    mimeType = "application/pdf";
  } else {
    mimeType =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  }

  const blob = new Blob([byteArray], { type: mimeType });
  const fileURL = URL.createObjectURL(blob);

  // Open the resume in a new tab
  window.open(fileURL, "_blank");
};

export default OpenResumeInNewTab;
